import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { buyWallet } from "../../redux/actions/bidding";
import { BUY_WALLET } from "../../redux/constants/bidding";
import { getSuccessActionType } from "../../redux/utils";
import Button from "../shared/button";
import WalletInput from "../shared/form/price-input";
import { addCommas, removeNonNumeric } from "../../utils/price-form-number";

interface Props {
  doctorId: number;
  balance: string;
  status: boolean;
}

const BiddingBudget = ({ doctorId, balance }: Props) => {
  const [valueBudgInc, setValueBudgInc] = useState(200000);
  const [increaseBudg, setIncreaseBudg] = useState(false);
  const dispatch = useDispatch();

  const onChange = (e: any) => {
    setValueBudgInc(removeNonNumeric(e.target.value));
  };
  const onSubmit = async () => {
    const res = await dispatch(buyWallet(doctorId, valueBudgInc));

    if (res.type === getSuccessActionType(BUY_WALLET)) {
      setIncreaseBudg(!increaseBudg);
      const payload = res.payload as unknown as { paymentUrl: string };
      window.location.href = payload.paymentUrl;
    }
  };

  return (
    <div className="mt-4 text-sm font-medium ">
      <div className="flex justify-between">
        <p> بودجه بازدید باقی مانده:</p>
        {!increaseBudg && (
          <p
            className="cursor-pointer text-pkc-dark-blue"
            onClick={() => setIncreaseBudg(!increaseBudg)}
            id="addBudget"
          >
            افزایش بودجه
          </p>
        )}
      </div>
      <div className="wallet_price">
        <WalletInput value={Number(balance).toLocaleString()} readOnly={true} />
      </div>

      {increaseBudg && (
        <>
          <div className="flex justify-between">
            <p> بودجه موردنظر شما برای افزایش:</p>
          </div>
          <div className="wallet_price">
            <WalletInput value={addCommas(valueBudgInc.toLocaleString())} background="white" onChange={onChange} />
          </div>

          <div className="grid grid-cols-2 gap-2 md:float-left md:w-1/2">
            <Button
              className="w-full !border-pkc-dark-blue !border-1 !text-pkc-dark-blue"
              variant="outline"
              onClick={onSubmit}
            >
              افزایش بودجه و پرداخت
            </Button>
            <Button
              className="!border-1 !border-pkc-red !text-pkc-red"
              variant="outline"
              onClick={() => {
                setValueBudgInc(200000);
                setIncreaseBudg(!increaseBudg);
              }}
            >
              انصراف
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default BiddingBudget;
